
export const restrictions = {
  minHeight: 200,
  maxHeight: 2500,
};

export const defaultDetails = {
  height: 600,
  showHeader: false,
  showBackground: true,
};

